import styled from "styled-components";

export const MetabaseReportsContainer = styled.div`
    padding: 16px;
    width: 100%;
`;

export const MetabaseDashboardContainer = styled.div`
    width: 100%;
`;

/* Yüksekliği iframe-resizer içerik boyuna göre inline olarak ayarlıyor;
   buradaki değer yalnızca resizer devreye girene kadarki başlangıç yüksekliği. */
export const MetabaseIframe = styled.iframe`
    display: block;
    border: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    width: 100%;
    height: calc(100vh - 200px);
`;
